<template>
  <v-app-bar
    class="blue accent-3"
    dense
    style="margin-bottom:20px;"
  >

    <v-btn fab x-small @click="onBack">
      <v-icon>navigate_before</v-icon>
    </v-btn>

    <v-spacer class="desktop"></v-spacer>

    <router-link
      :to="{
        name: 'Program Dashboard',
        params: { programID: programID },
      }"
    >
      <v-btn
        color="transparent"
        class="ma-1 desktop white--text"
        small
        depressed
        >Dashboard</v-btn
      >
    </router-link>

          <router-link
      :to="{
        name: 'ProgramMaintenance',
        params: { programID: programID },
      }"
    >
      <v-btn
        color="transparent"
        class="ma-1 desktop white--text"
        small
        depressed
        >Maintenance</v-btn
      >
    </router-link>

    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="transparent"
          v-bind="attrs"
          v-on="on"
          class="ma-1 desktop white--text"
          small
          depressed
        >
          Reporting
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          router
          :to="{
            name: 'Program Fire Drill',
            params: { programID: programID },
          }"
        >
          <v-list-item-title>Fire Drills</v-list-item-title>
        </v-list-item>
        <v-list-item
          router
          :to="{
            name: 'Water Temperature Tracking',
            params: { programID: programID },
          }"
        >
          <v-list-item-title>Water Temperature Tracking</v-list-item-title>
        </v-list-item>
        <v-list-item
          router
          :to="{
            name: 'ProgramInventory',
            params: { programID: programID },
          }"
        >
          <v-list-item-title>Inventory</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="transparent"
          v-bind="attrs"
          v-on="on"
          class="ma-1 desktop white--text"
          small
          depressed
        >
          Document Library
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="doc in documents"
          :key="doc.title"
          router
          :to="{
            name: doc.name,
            params: { programID: programID },
          }"
        >
          <v-list-item-title>{{ doc.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    

    <v-spacer></v-spacer>

    <v-menu offset-y close-on-content-click="">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" class="ma-1 mobile" small depressed>
          Program Menu
        </v-btn>
      </template>

      <v-list mandatory>
        <v-list-item
          router
          :to="{
            name: 'Program Dashboard',
            params: { programID: programID },
          }"
        >
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>

        <v-list-item
          router
          :to="{
            name: 'ProgramMaintenance',
            params: { programID: programID },
          }"
        >
          <v-list-item-title>Maintenance</v-list-item-title>
        </v-list-item>

        <v-list-item
          router
          :to="{
            name: 'ProgramInventory',
            params: { programID: programID },
          }"
        >
          <v-list-item-title>Inventory</v-list-item-title>
        </v-list-item>
        
        <v-list-group prepend-icon="mdi-account-circle" @click.stop.prevent>
          <template v-slot:activator>
            <v-list-item-title>Reporting</v-list-item-title>
          </template>
          
          <v-list-item
            router
            :to="{
              name: 'Program Fire Drill',
              params: { programID: programID },
            }"
          >
            <v-list-item-title>Fire Drills</v-list-item-title>
          </v-list-item>
          
          <v-list-item
            router
            :to="{
              name: 'Water Temperature Tracking',
              params: { programID: programID },
            }"
          >
            <v-list-item-title>Water Temperature Tracking</v-list-item-title>
          </v-list-item>
          
          <v-list-item
            router
            :to="{
              name: 'ProgramInventory',
              params: { programID: programID },
            }"
          >
            <v-list-item-title>Inventory</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group prepend-icon="mdi-account-circle" @click.stop.prevent>
          <template v-slot:activator>
            <v-list-item-title>Document Library</v-list-item-title>
          </template>

          <v-list-item
            v-for="doc in documents"
            :key="doc.title"
            router
            :to="{
              name: doc.name,
              params: { programID: programID },
            }"
          >
            <v-list-item-title>{{ doc.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-menu>

    <v-spacer class="mobile"></v-spacer>
  </v-app-bar>
</template>
<script>
// import axios from "axios";
// const url = require("@/client_config/config").url;
import { mapActions, mapState } from "vuex";
export default {
  props: {
    programID: String
  },
  data: () => ({
    icon: "",
    documents: [{ title: "View Library", name: "ProgramDocuments" }],
  }),

  computed: {
    ...mapState("users", ["user"]),
    currentEmployeeID() {
      return (this.user && (this.user._id || this.user.id)) || localStorage.getItem("userID");
    },
  },

  mounted() {
    this.getUser();
  },
  methods: {
    ...mapActions("users", ["getUser"]),
    onBack() {
      // Prefer navigating back to the program dashboard if coming from a nested view with query params
      const hasQueryId = !!this.$route.query.id;
      const isWaterTempChart = this.$route.name === 'Water Temperature Tracking Chart';
      if (hasQueryId && isWaterTempChart) {
        // go back to the WTT list for the same program
        this.$router.push({ name: 'Water Temperature Tracking', params: { programID: this.programID } });
      } else {
        this.$router.go(-1);
      }
    }
  },
};
</script>
<style>
.back-button {
  color: white !important;
}

@media only screen and (max-width: 600px) {
  .v-menu.mobile {
    display: none;
  }
}
@media only screen and (max-width: 480px) {
  .v-menu.desktop {
    display: none;
  }
}
</style>